// extracted by mini-css-extract-plugin
module.exports = {"profileContent":"styles_profileContent__3e7Mr","formTitle":"styles_formTitle__14KM9","formContent":"styles_formContent__1680G"};